export default "__VITE_ASSET__DRyjiPw___"